// Edge calls for presence ("open to taste together"): the heartbeat, the switch and the read of
// who in your circles is open. Same choke point and shape as friendsApi.ts.
import {
  PatchPresenceRequest,
  PresenceHeartbeat,
  PresenceList,
  PresenceSelf,
  type PresenceActivityReport,
  type PresenceEntry,
} from "@proef/contract";
import { call } from "../edgeApi";

/** `PUT /v1/presence`: a foregrounded app reports itself. Answers whether presence is on, and
 * stores nothing when it is off. `activity` is the tasting under way, `null` ends the one this
 * device reported, and leaving it out (an idle device) keeps whatever another device reported. */
export function sendHeartbeat(activity?: PresenceActivityReport | null): Promise<PresenceSelf> {
  return call(PresenceSelf, "/v1/presence", {
    method: "PUT",
    ...(activity === undefined
      ? {}
      : { body: JSON.stringify(PresenceHeartbeat.parse({ activity })) }),
  });
}

export function getMyPresence(): Promise<PresenceSelf> {
  return call(PresenceSelf, "/v1/presence/me");
}

/** `PATCH /v1/presence`: the settings switch. */
export function setPresenceEnabled(enabled: boolean): Promise<PresenceSelf> {
  return call(PresenceSelf, "/v1/presence", {
    method: "PATCH",
    body: JSON.stringify(PatchPresenceRequest.parse({ enabled })),
  });
}

/** `GET /v1/presence/friends`: friends and group members who are open or were recently active. */
export function listPresence(): Promise<PresenceList> {
  return call(PresenceList, "/v1/presence/friends");
}

export type { PresenceEntry, PresenceSelf };
